var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1615 18.6667V7.58333C22.1615 6.3 21.1115 5.25 19.8281 5.25H14.5781",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.33301L14 5.24967L17.5 8.16634",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 10.5V18.6667",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11979 9.91732C8.21387 9.91732 9.91146 8.21973 9.91146 6.12565C9.91146 4.03157 8.21387 2.33398 6.11979 2.33398C4.02571 2.33398 2.32812 4.03157 2.32812 6.12565C2.32812 8.21973 4.02571 9.91732 6.11979 9.91732Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 25.666C7.76112 25.666 9.32812 24.099 9.32812 22.166C9.32812 20.233 7.76112 18.666 5.82812 18.666C3.89513 18.666 2.32812 20.233 2.32812 22.166C2.32812 24.099 3.89513 25.666 5.82812 25.666Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1719 25.666C24.1049 25.666 25.6719 24.099 25.6719 22.166C25.6719 20.233 24.1049 18.666 22.1719 18.666C20.2389 18.666 18.6719 20.233 18.6719 22.166C18.6719 24.099 20.2389 25.666 22.1719 25.666Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.91104d86aa125aad2c2037dd765db48e.svg";
export { ForwardRef as ReactComponent };